import { useState } from "react";
import products from "../data/products";

function Home({ addToCart }) {
  const [query, setQuery] = useState("");

  const filtered = products.filter((p) =>
    p.name.toLowerCase().includes(query.toLowerCase())
  );

  return (
    <div className="min-h-screen bg-[#0d0d0f] text-white [font-family:'Syne',sans-serif]">
      <link href="https://fonts.googleapis.com/css2?family=Syne:wght@400;500;600;700&display=swap" rel="stylesheet" />

      {/* Hero */}
      <section className="max-w-7xl mx-auto px-6 py-10 border-b border-white/5">
        <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-4">
          <div>
            <p className="text-[0.65rem] font-medium tracking-[0.22em] uppercase text-[#6f5bff] mb-3">
              Store
            </p>
            <h1 className="text-3xl font-semibold tracking-tight text-white">
              Gaming Accessories
            </h1>
            <p className="text-gray-500 mt-2 text-sm">
              Built for performance. Designed for focus.
            </p>
          </div>

          {/* Search */}
          <div className="flex items-center gap-2 bg-[#141416] border border-white/[0.07] rounded-lg px-3 py-2 w-full sm:max-w-xs sm:mt-1 focus-within:border-[#6f5bff]/50 transition-colors duration-200">
            <svg className="w-3.5 h-3.5 text-gray-500 shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M21 21l-4.35-4.35M17 11A6 6 0 115 11a6 6 0 0112 0z" />
            </svg>
            <input
              type="text"
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              placeholder="Search products..."
              className="bg-transparent text-[0.78rem] text-white placeholder-gray-600 outline-none w-full"
            />
            {query && (
              <button onClick={() => setQuery("")} className="text-gray-600 hover:text-gray-400 transition-colors">
                <svg className="w-3 h-3" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            )}
          </div>
        </div>
      </section>

      {/* Products */}
      <section className="max-w-7xl mx-auto px-4 sm:px-6 py-10">
        <div className="flex items-center justify-between mb-6">
          <h2 className="text-sm font-medium text-gray-400 uppercase tracking-widest">
            Products
          </h2>
          <span className="text-xs text-gray-600">
            {filtered.length} {query ? "results" : "items"}
          </span>
        </div>

        {filtered.length === 0 ? (
          <div className="flex flex-col items-center justify-center py-24 gap-3">
            <svg className="w-8 h-8 text-gray-700" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.2}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M21 21l-4.35-4.35M17 11A6 6 0 115 11a6 6 0 0112 0z" />
            </svg>
            <p className="text-gray-600 text-sm">No products found for "{query}"</p>
            <button
              onClick={() => setQuery("")}
              className="text-[0.75rem] text-[#8b7dff] hover:text-[#6f5bff] transition-colors duration-200"
            >
              Clear search
            </button>
          </div>
        ) : (
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3">
            {filtered.map((p) => (
              <div
                key={p.id}
                className="bg-[#141416] border border-white/[0.07] rounded-[10px] overflow-hidden
                  transition-all duration-[250ms] ease-in-out
                  hover:border-[#6f5bff]/45 hover:shadow-[0_8px_32px_rgba(111,91,255,0.12)] hover:-translate-y-0.5
                  group"
              >
                <div className="h-24 sm:h-36 flex items-center justify-center px-3 sm:px-5 [background:radial-gradient(ellipse_at_50%_70%,#1e1b35_0%,#111113_100%)]">
                  <img
                    src={p.image}
                    alt={p.name}
                    className="h-full object-contain transition-all duration-300 ease-in-out
                      group-hover:scale-[1.04] group-hover:[filter:drop-shadow(0_6px_16px_rgba(111,91,255,0.25))]"
                  />
                </div>

                <div className="p-2.5 sm:p-3 border-t border-white/5">
                  <h3 className="text-xs sm:text-sm font-medium text-white leading-snug line-clamp-2">
                    {p.name}
                  </h3>
                  <p className="text-sm font-semibold mt-1 text-[#8b7dff]">₹{p.price}</p>
                  <button
                    onClick={() => addToCart(p)}
                    className="mt-2.5 w-full py-1.5 text-white text-[0.7rem] sm:text-[0.75rem] font-semibold tracking-[0.04em]
                      bg-[#6f5bff] rounded-md hover:bg-[#8472ff] active:scale-[0.98]
                      transition-all duration-200 ease-in-out"
                  >
                    Add to Cart
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}
      </section>
    </div>
  );
}

export default Home;